import type { MasterSearchGroup } from "api/masterSearch";
import { ENTITY_TYPE_LABELS, ENTITY_TYPE_ORDER } from "./constants";

export const orderVisibleGroups = (groups: MasterSearchGroup[]) =>
  [...groups]
    .filter((group) => Boolean(ENTITY_TYPE_LABELS[group.type]))
    .filter((group) => group.items.length > 0)
    .sort(
      (a, b) =>
        ENTITY_TYPE_ORDER.indexOf(a.type) - ENTITY_TYPE_ORDER.indexOf(b.type)
    );

export const flattenGroupItems = (groups: MasterSearchGroup[]) =>
  orderVisibleGroups(groups).flatMap((group) => group.items);
